<template>
    <div class="image_saver_task">
        <!-- 任务主体 -->
        <div class="image_saver_task_body">
            <!-- 清理历史 -->
            <div @click="clearTask(activeSubTab)" class="image_saver_task_clear">{{ $t('language.imageSaver.clearHistory') }}</div>
            <!-- 切换Tab -->
            <el-tabs v-model="activeSubTab" @tab-click="switchTab" class="image_saver_task_tab" ref="imageSaverSubTab">
                <!-- 任务未初始化 -->
                <div v-if="taskNotInit" class="image_saver_task_not_init"></div>
                <!-- 保存单个 -->
                <el-tab-pane :label="$t('language.imageSaver.taskTabUpload')" name="saveOne" :style="{backgroundColor:(tasksSaveOne.length==0?'transparent':'#FFF')}">
                    <!-- 没有任务 -->
                    <div v-if="tasksSaveOne.length == 0 && !taskNotInit" class="image_saver_task_no" :style="{height:noTaskHeight+'px'}">
                        <div class="image_saver_task_no_content">
                            <img src="../../assets/images/imageSaver/taskNo.svg" />
                            <div>{{ $t('language.imageSaver.noTask') }}</div>
                        </div>
                    </div>
                    <!-- 有任务 -->
                    <div v-if="tasksSaveOne.length != 0" class="image_saver_task_items">
                        <!-- 单个任务 -->
                        <div v-for="(task, index) of tasksSaveOne" :key="task.id" class="image_saver_task_item"
                            :style="{width:viewImgWigth+'px',height:viewImgWigth+'px'}"
                            :class="'image_saver_' + task.status">
                            <!-- 预览图 -->
                            <img :src="task.fromData.pre ? task.fromData.pre : task.fromData.url" @error="previewError($event)" :class="'imagesaver_' + task.fromType + ' imagesaver_' + task.fromData.type" />
                            <!-- 大任务图标，已迁移到另一个Tab -->
                            <div v-if="task.fromData.type == 'all'" class="image_saver_task_all"></div>
                            <!-- 大任务详情，已迁移到另一个Tab -->
                            <div v-if="task.fromData.type == 'all'" class="image_saver_task_detail">
                                <!-- 大任务成功 -->
                                <div class="detail_success">
                                    <img src="../../assets/images/imageSaver/insTaskHover.svg"/>
                                    <span>{{ decodeDetail(task, 'success') + decodeDetail(task, 'skip') }}</span>
                                </div>
                                <!-- 大任务失败 -->
                                <div class="detail_error">{{ $t('language.common.failed') }}: {{ decodeDetail(task, 'error') }}</div>
                            </div>
                            <!-- 视频图标 -->
                            <div v-if="task.fromData.type == 'video'" class="image_saver_task_video"></div>
                            <!-- 圆形进度 -->
                            <div v-if="task.status == 'create' || task.status == 'run'" class="image_saver_task_prog">
                                <el-progress type="circle" :width="32" :stroke-width="16" :percentage="decodePercentage(task)"
                                    :show-text="false" define-back-color="rgba(0,0,0,0.3)" color="#FFF"
                                    stroke-linecap="butt"></el-progress>
                            </div>
                            <!-- 成功图标 -->
                            <div v-if="task.tempSuccess" class="image_saver_task_success"></div>
                            <!-- 失败图标 -->
                            <div v-if="task.status == 'error'" class="image_saver_task_error"></div>
                            <!-- 取消 -->
                            <div @click="cancelTask(task.id)" class="image_saver_task_cancel">{{ $t('language.imageSaver.cancel') }}</div>
                            <!-- 查看 -->
                            <div @click="viewTask(task)" class="image_saver_task_view">{{ $t('language.imageSaver.view') }}</div>
                            <!-- 重试 -->
                            <div @click="retryTask(task.id)" class="image_saver_task_retry">{{ $t('language.imageSaver.retry') }}</div>
                        </div>
                    </div>
                </el-tab-pane>
                <!-- 保存所有 -->
                <el-tab-pane :label="$t('language.imageSaver.taskTabSaveAll')" name="saveAll">
                    <!-- 没有任务 -->
                    <div v-if="tasksSaveAll.length == 0 && !taskNotInit" class="image_saver_task_no" :style="{height:noTaskHeight+'px'}">
                        <div class="image_saver_task_no_content">
                            <img src="../../assets/images/imageSaver/taskNo.svg" />
                            <div>{{ $t('language.imageSaver.noTask') }}</div>
                        </div>
                    </div>
                    <!-- 有任务 -->
                    <div v-if="tasksSaveAll.length != 0" class="image_saver_width_tasks">
                        <!-- 单个任务 -->
                        <div v-for="(task, index) of tasksSaveAll" :key="task.id" class="image_saver_width_task" :class="'image_saver_width_' + task.status" :data-traffic="errorIsNoTraffic(task)?'Y':'N'" :data-noprog="isNoProg(task)?'Y':'N'" :data-warn="isWarnNotError(task)?'Y':'N'">
                            <!-- 大图标 -->
                            <img class="image_saver_width_task_icon" :src="task.fromData.pre ? task.fromData.pre : task.fromData.url" @error="previewError($event)" :class="'imagesaver_' + task.fromType + ' imagesaver_' + task.fromData.type">
                            <!-- 名称 -->
                            <div class="image_saver_width_task_name">{{ taskNameFormat(task) }}</div>
                            <!-- 详情 -->
                            <div class="image_saver_width_task_info">{{ decodeWidthInfo(task) }}</div>
                            <!-- 进度 -->
                            <div class="image_saver_width_task_prog">
                                <!-- 条形进度 -->
                                <div class="image_saver_width_task_prog_bg">
                                    <!-- 当前进度 -->
                                    <div class="image_saver_width_task_prog_cur" :style="{width:decodeWidthProg(task)}"></div>
                                </div>
                                <!-- 进度，左边文字 -->
                                <div class="image_saver_width_task_prog_left">{{ decodeWidthSpeed(task) }}</div>
                                <!-- 进度，右边文字 -->
                                <div class="image_saver_width_task_prog_right">{{ decodeWidthProgText(task) }}</div>
                            </div>
                            <!-- 状态 -->
                            <div class="image_saver_width_task_status" :msg="decodeWidthMsgTitle(task)">{{ decodeWidthMsg(task) }}</div>
                            <!-- 取消 -->
                            <div class="image_saver_width_task_cancel" @click="cancelTask(task.id)">{{ $t('language.imageSaver.cancel') }}</div>
                            <!-- 查看 -->
                            <div class="image_saver_width_task_view" @click="viewTask(task)"></div>
                            <!-- 重试 -->
                            <div class="image_saver_width_task_retry" @click="retryTask(task.id)"></div>
                            <!-- 升级 -->
                            <div class="image_saver_width_task_upgrade" @click="showUpgradeNewDialog()" v-show="isTrafficNotEnough()">
                                <img src="../../assets/images/imageSaver/widthUpgrade.svg" >
                                <span>{{$t('language.rightTopBanner.upgrade')}}</span>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <!-- Instagram下载所有 -->
                <el-tab-pane :label="$t('language.imageSaver.taskTabDownload')" name="downloadAll" v-if="isInsTaskList">
                    <!-- 没有任务 -->
                    <div v-if="tasksDownloadAll.length == 0 && !taskNotInit" class="image_saver_task_no" :style="{height:noTaskHeight+'px'}">
                        <div class="image_saver_task_no_content">
                            <img src="../../assets/images/imageSaver/taskNo.svg" />
                            <div>{{ $t('language.imageSaver.noTask') }}</div>
                        </div>
                    </div>
                    <!-- 有任务 -->
                    <div v-if="tasksDownloadAll.length != 0" class="image_saver_width_tasks instagram_tasks">
                        <!-- 单个任务 -->
                        <div v-for="(task, index) of tasksDownloadAll" :key="task.id" class="image_saver_width_task" :class="'image_saver_width_' + task.status" :data-traffic="errorIsNoTraffic(task)?'Y':'N'" :data-overdue="taskIsOverdue(task)?'Y':'N'" :data-limit="taskIsLimit(task)?'Y':'N'" :data-warn="isWarnNotError(task)?'Y':'N'" :data-noprog="isNoProg(task)?'Y':'N'">
                            <!-- 大图标 -->
                            <img class="image_saver_width_task_icon" :src="task.fromData.pre ? task.fromData.pre : task.fromData.url" @error="previewError($event)" :class="'imagesaver_' + task.fromType + ' imagesaver_' + task.fromData.type">
                            <!-- 名称 -->
                            <div class="image_saver_width_task_name2" @click="openInstagramWebPage(task)">
                                <span>{{ taskNameFormat(task) }}</span>
                            </div>
                            <!-- 详情 -->
                            <div class="image_saver_width_task_info">{{ decodeWidthInfo(task) }}</div>
                            <!-- 进度 -->
                            <div class="image_saver_width_task_prog">
                                <!-- 条形进度 -->
                                <div class="image_saver_width_task_prog_bg">
                                    <!-- 当前进度 -->
                                    <div class="image_saver_width_task_prog_cur" :style="{width:decodeWidthProg(task)}"></div>
                                </div>
                                <!-- 进度，左边文字 -->
                                <div class="image_saver_width_task_prog_left">{{ decodeWidthSpeed(task) }}</div>
                                <!-- 进度，右边文字 -->
                                <div class="image_saver_width_task_prog_right">{{ decodeWidthProgText(task) }}</div>
                            </div>
                            <!-- 状态 -->
                            <div class="image_saver_width_task_status" :msg="decodeWidthMsgTitle(task)">{{ decodeWidthMsg(task) }}</div>
                            <!-- 过期 -->
                            <div class="image_saver_width_task_overdue">{{ decodeWidthOverdue(task) }}</div>
                            <!-- 取消 -->
                            <div class="image_saver_width_task_cancel" @click="cancelTask(task.id)">{{ $t('language.imageSaver.cancel') }}</div>
                            <!-- 下载所有 -->
                            <div class="image_saver_width_task_download_all"  @click="downloadPart(task,0,true)" v-show="isShowDwonloadAllNormal(task)">{{ $t('language.imageSaver.downloadAll') }}</div>
                            <!-- 重试 -->
                            <div class="image_saver_width_task_retry" @click="retryTask(task.id)"></div>
                            <!-- 升级 -->
                            <div class="image_saver_width_task_upgrade2" @click="showUpgradeNewDialog()" v-show="isShowUpgrade2Btn(task)">
                                <img src="../../assets/images/imageSaver/widthUpgrade.svg" >
                                <span>{{$t('language.rightTopBanner.upgrade')}}</span>
                            </div>
                            <!-- 升级，下载所有 -->
                            <div class="image_saver_width_task_upgrade2_download_all" @click="showUpgradeNewDialog()" v-show="isShowDwonloadAllUpgrade(task)">
                                <img src="../../assets/images/imageSaver/widthUpgrade.svg" >
                                <span>{{ $t('language.imageSaver.downloadAll') }}</span>
                            </div>
                            <!-- 分包下载 -->
                            <div class="image_saver_width_task_parts" v-show="isShowDwonloadAllNormal(task)">
                                <div class="image_saver_width_task_part" v-for="(part, index2) of decodeWidthParts(task)" :key="part.uuid" :data-status="part.flag?'yes':'no'" @click="downloadPart(task,index2+1,part.flag)">
                                    <img class="image_saver_width_task_part_zip" src="../../assets/images/imageSaver/partZip.svg" />
                                    <div class="image_saver_width_task_part_num">{{ $t('language.imageSaver.taskPart') + ' ' + (index2+1) }}</div>
                                    <img class="image_saver_width_task_part_download" src="../../assets/images/imageSaver/partDownload.svg" />
                                    <img class="image_saver_width_task_part_upgrade" src="../../assets/images/imageSaver/partUpgrade.svg" />
                                    <div class="image_saver_width_task_part_info">{{part.flag ? filesUnitText(part.count)+"("+formatBytes(part.size)+")" : ""}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <!-- 波浪 -->
        <div class="task-buttom"></div>
        <!-- 付费用户升级 -->
        <upgradeVipDialog ref="upgradeVipDialog"></upgradeVipDialog>
        <!-- 免费用户升级 -->
        <upgradeNewDialog ref="upgradeNewDialog"></upgradeNewDialog>
    </div>
</template>

<script>
import Vue from 'vue';
import upgradeVipDialog from "@/components/popup/upgrade_popups/upgrade_account_vip_popup";
import upgradeNewDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";
import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";

export default {
    name: "imageSaverTask",
    components: {
        upgradeVipDialog,
        upgradeNewDialog,
    },
    data() {
        return {
            // 预览图宽
            viewImgWigth: 0,
            // 任务未初始化
            taskNotInit: true,
            // 没有任务高度
            noTaskHeight: 0,
            // 任务数据
            tasks: [],
            // 是否正在加载进度
            isLoadProg: false,
            // 加载进度错误计数
            loadProgErrorCount: 0,
            // 前后端任务是否同步（0：已同步，大于0：N次未同步）
            taskSyncFlag: 0,
            // 默认Tab页
            activeSubTab: this.$cookies.get('imagesaverTaskTab')?this.$cookies.get('imagesaverTaskTab'):'saveOne',
            // 这是一个透明图片，啥都没有
            previewErrorImg: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkVFRTM3MDUyMThGRDExRUZCRUQ4Q0MyNzRERkVFM0UzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkVFRTM3MDUzMThGRDExRUZCRUQ4Q0MyNzRERkVFM0UzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RUVFMzcwNTAxOEZEMTFFRkJFRDhDQzI3NERGRUUzRTMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RUVFMzcwNTExOEZEMTFFRkJFRDhDQzI3NERGRUUzRTMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5Exga6AAAAFUlEQVR42mL8//8/AwgwMUABQIABADAGAwGo78J/AAAAAElFTkSuQmCC',
            // 正在删除任务
            deleteTasking: false,
            // 最后删除任务的时间
            deleteTaskLastTime: 0,
            // 是否是Ins任务列表
            isInsTaskList: this.$store.state.isInsTaskList,
        };
    },
    watch: {
        // 监听任务变化
        '$store.state.imageSaverTaskDatas': function(newValue) {
            this.tasks = newValue;
            this.taskNotInit = false;
        },
        // 监听Ins任务列表和Web任务列表的变化
        '$store.state.isInsTaskList': function(newValue) {
            this.isInsTaskList = newValue;
            // 非Ins任务，没有下载所有的任务类型
            if (!newValue && this.activeSubTab=='downloadAll') {
                this.activeSubTab = 'saveAll';
                this.$cookies.set("imagesaverTaskTab", this.activeSubTab, "1y");
            }
        },
    },
    computed: {
        // 保存单个的任务
        tasksSaveOne() {
            var arr = [];
            for (var i=0; i<this.tasks.length; i++) {
                var task = this.tasks[i];
                if ((this.isInsTaskList&&task.fromType=='instagram') || (!this.isInsTaskList&&task.fromType!='instagram')) {
                    if (task.fromData.type == 'image' || task.fromData.type == 'video') {
                        arr.push(task);
                    }
                }
            }
            return arr;
        },
        // 保存所有的任务
        tasksSaveAll() {
            var arr = [];
            for (var i=0; i<this.tasks.length; i++) {
                var task = this.tasks[i];
                if ((this.isInsTaskList&&task.fromType=='instagram') || (!this.isInsTaskList&&task.fromType!='instagram')) {
                    if (task.fromData.type == 'all') {
                        arr.push(task);
                    }
                }
            }
            return arr;
        },
        // 下载所有的任务
        tasksDownloadAll() {
            var arr = [];
            for (var i=0; i<this.tasks.length; i++) {
                var task = this.tasks[i];
                if ((this.isInsTaskList&&task.fromType=='instagram') || (!this.isInsTaskList&&task.fromType!='instagram')) {
                    if (task.fromData.type == 'download_all') {
                        arr.push(task);
                    }
                }
            }
            return arr;
        },
        // 未完成的任务计数（显示）
        unfinishTaskCount() {
            var count = 0;
            for (var i = 0; i < this.tasks.length; i++) {
                var status = this.tasks[i].status;
                if (status == 'create' || status == 'run') {
                    count++;
                } else if (status == 'error' && this.tasks[i].msg == 'limit') {
                    count++;
                }
            }
            return count;
        },
        // 未完成的任务计数（真）
        unfinishTaskCountReal() {
            var count = 0;
            for (var i = 0; i < this.tasks.length; i++) {
                var status = this.tasks[i].status;
                if (status == 'create' || status == 'run') {
                    count++;
                }
            }
            return count;
        }
    },
    mounted() {
        // 初始化窗口大小变化
        this.updateWindowSize();
        // 监听窗口大小变化
        window.addEventListener('resize', this.updateWindowSize);
        // 保证刷新后Tab下划线正常
        this.repairTabUnderline();
        // 列出任务
        this.listTask();
        // 检测刚完成的单个保存任务
        this.chickSaveOneTask = setInterval(() => {
            for (var i=0; i<this.tasks.length; i++) {
                if (this.tasks[i].tempSuccess) {
                    if (this.tasks[i].tempSuccessFlag) {
                        Vue.delete(this.tasks[i], 'tempSuccess');
                        Vue.delete(this.tasks[i], 'tempSuccessFlag');
                    } else {
                        Vue.set(this.tasks[i], 'tempSuccessFlag', true);
                    }
                }
            }
        }, 1000);
        // 获取任务进度
        this.loadImageSaverTasksProg = setInterval(() => {
            // 是Ins和Web相关页面才获取进度
            if (this.$route.path.indexOf('/mc_project/image_saver_') == -1) return;
            // 真有未完成任务 或 假有未完成任务
            if (this.unfinishTaskCount > 0) {
                // 正在加载进度，这次不加载
                if (this.isLoadProg) {
                    if (this.loadProgErrorCount < 3) {
                        this.loadProgErrorCount += 1;
                    } else {
                        this.loadProgErrorCount = 0;
                        this.isLoadProg = false;
                    }
                    return;
                }
                // 同时加载任务预览图会出问题，把tempTask定义到这里，且是对象就没有问题
                var tempTask = {};
                this.isLoadProg = true;
                taskListUtils.imageSaverRequest("/prog", {}, res => {
                    if (res.code == 200) {
                        var tempData = res.data;
                        var size = tempData.size;
                        var data = tempData.prog;
                        // 刷新流量
                        if (this.unfinishTaskCountReal != tempData.remain) {
                            commonUtils.refreshUserInfo(this, function(res) {});
                        }
                        // 已经不存在的任务
                        var notExistTask = [];
                        // 有Instagram下载任务完成
                        var hasInsDownDone = false;
                        // 更新状态和进度
                        for (var i = 0; i < this.tasks.length; i++) {
                            // 检测不存在的任务
                            if (!data[this.tasks[i].id]) {
                                notExistTask.push(this.tasks[i].id);
                                continue;
                            }
                            // 视情况，更新预览图
                            // 上次的状态是run或create
                            if (this.tasks[i].status == 'run' || this.tasks[i].status == 'create') {
                                var curStatus = data[this.tasks[i].id].status;
                                var fromDataType = this.tasks[i].fromData.type;
                                // 单个保存任务完成
                                if (curStatus=='success' && (fromDataType=='image'||fromDataType=='video')) {
                                    Vue.set(this.tasks[i], 'tempSuccess', true);
                                }
                                // 有Instagram下载任务完成
                                if ((curStatus=='success'||curStatus=='error') && fromDataType=='download_all') {
                                    hasInsDownDone = true;
                                }
                                // 这次的状态是success
                                if (curStatus == 'success') {
                                    // 是instagram类型的资源
                                    if (this.tasks[i].fromType == 'instagram') {
                                        // 上次没有预览图
                                        if (this.tasks[i].fromData.pre == '#') {
                                            // 准备加载任务预览图
                                            tempTask[this.tasks[i].id] = this.tasks[i];
                                            taskListUtils.imageSaverRequest("/loadFromData", {id:this.tasks[i].id}, res => {
                                                if (res.code == 200) {
                                                    Vue.set(tempTask[res.data.id], 'fromData', res.data.bean);
                                                }
                                            });
                                        }
                                    }
                                }
                            }
                            // 更新状态和进度和修改时间
                            this.tasks[i].status = data[this.tasks[i].id].status;
                            this.tasks[i].msg = data[this.tasks[i].id].msg;
                            this.tasks[i].mtime = data[this.tasks[i].id].mtime;
                        }
                        // 如果任务数量对不上，说明任务有新增，则刷新任务
                        // 或者说有任务被删除
                        // 有Instagram下载任务完成
                        if (size != this.tasks.length || notExistTask.length > 0 || hasInsDownDone) {
                            this.taskSyncFlag = this.taskSyncFlag + 1;
                            // 6次未同步，每次的间隔是5秒，也就是30秒未同步就刷新
                            // 或者说有任务被删除
                            if (this.taskSyncFlag >= 6 || notExistTask.length > 0 || hasInsDownDone) {
                                this.taskSyncFlag = 0;
                                this.listTask();
                            }
                        } else {
                            this.taskSyncFlag = 0;
                        }
                    } else if (res.message == 'saltInvalid') {
                        // 账号被挤下去了
                        commonUtils.logoutAndJumpToSign();
                    }
                    // 标记已完成进度加载
                    this.isLoadProg = false;
                });
            } else {
                // 没有任务的情况下也会每个30秒刷新一次任务
                this.taskSyncFlag = this.taskSyncFlag + 1;
                if (this.taskSyncFlag >= 6) {
                    this.taskSyncFlag = 0;
                    this.listTask();
                }
            }
        }, 5000);
    },
    beforeDestroy() {
        // 清理定时器
        clearInterval(this.chickSaveOneTask);
        clearInterval(this.loadImageSaverTasksProg);
        // 移除窗口大小变化的监听
        window.removeEventListener('resize', this.updateWindowSize);
    },
    activated() {
        // 查看任务时，是否需要切换Tab
        let cookieSubTab = this.$cookies.get('imagesaverTaskTab');
        if (cookieSubTab && cookieSubTab!=this.activeSubTab) {
            this.activeSubTab = cookieSubTab;
        }
    },
    methods: {
        // 切换Tab
        switchTab() {
            this.$cookies.set("imagesaverTaskTab", this.activeSubTab, "1y");
        },
        // 更新窗口大小
        updateWindowSize() {
            // 没有任务的高度
            this.noTaskHeight = window.innerHeight - 250;
            // 计算预览图宽
            var boxWigth = window.innerWidth - 408;
            var minWidth = 240;
            var maxWidth = 340;
            var lineCount = Math.floor((boxWigth/minWidth+boxWigth/maxWidth)/2);
            this.viewImgWigth = Math.floor(boxWigth / lineCount) - 14;
        },
        // 重试任务
        retryTask(id) {
            var index = this.getTaskIndex(id);
            if (index < 0) return;
            // 先检测流量是否足够
            if (this.tasks[index].fromData.type != 'download_all') {
                if (this.isTrafficNotEnough()) {
                    this.showUpgradeNewDialog();
                    return;
                }
            }
            // 再执行重试
            taskListUtils.imageSaverRequest("/retry", { id: this.tasks[index].id }, res => {
                if (res.code == 200) {
                    this.tasks[index].status = 'create';
                    this.tasks[index].msg = '';
                } else if (res.message == 'limit') {
                    this.showUpgradeNewDialog(true);
                } else {
                    this.errorTips(res.message);
                }
            });
        },
        // 取消任务
        cancelTask(id) {
            // 获取任务下标
            var index = this.getTaskIndex(id);
            // 任务存在且当前没有正在删除任务，才会开始删除任务
            if (index < 0 || this.deleteTasking) return;
            // 标记开始删除任务
            this.deleteTasking = true;
            // 标记开始删除任务的时间
            this.deleteTaskLastTime = new Date().getTime();
            // 发送请求
            taskListUtils.imageSaverRequest("/deleteTask", { id: this.tasks[index].id }, res => {
                // 标记删除任务完成
                this.deleteTasking = false;
                if (res.code == 200) {
                    // 请求成功，再次获取任务下标
                    index = this.getTaskIndex(id);
                    // 下标存在
                    if (index >= 0) {
                        // 移除任务
                        this.tasks.splice(index, 1);
                        // 等会刷新任务列表
                        setTimeout(() => {
                            // 连续删除任务的情况下，最后一次删除后等会才刷新列表
                            if (new Date().getTime() - this.deleteTaskLastTime > 4000) {
                                this.listTask();
                            }
                        }, 5000);
                    }
                } else {
                    // 删除异常
                    this.errorTips(res.message);
                }
            }, err => {
                // 标记删除任务完成
                this.deleteTasking = false;
            });
        },
        // 清理任务
        clearTask(type) {
            if (this.tasks.length != 0) {
                taskListUtils.imageSaverRequest("/clearDone", {type:type,isInsTaskList:this.isInsTaskList}, res => {
                    if (res.code == 200) {
                        this.listTask();
                    } else if (res.message == 'server_error') {
                        this.errorTips('Server error, please try again later.');
                    } else {
                        this.errorTips(res.message);
                    }
                });
            }
        },
        // 列出任务
        listTask() {
            taskListUtils.imageSaverRequest("/list", {}, res => {
                if (res.code == 200) {
                    commonUtils.updateImageSaverTasks(res.data);
                } else if (res.message == 'saltInvalid') {
                    commonUtils.logoutAndJumpToSign();
                } else {
                    this.errorTips(res.message);
                }
            });
        },
        // 获取任务Index
        getTaskIndex(id) {
            for (var i=0; i<this.tasks.length; i++) {
                if (this.tasks[i].id == id) {
                    return i;
                }
            }
        },
        // 错误提示
        errorTips(msg) {
            this.$toast({
                text: msg,
                type: 'fail',
                idValue: "allBox"
            });
        },
        // 修复任务列表Tab下划线错位问题
        repairTabUnderline() {
            // Tab
            var imageSaverSubTab = this.$refs.imageSaverSubTab;
            // 激活的Tab
            var activeSubTab = this.activeSubTab;
            // Tab的索引
            var tabIndex = 0;
            // 是否是开始和结束Tab
            var isFirstLast = false;
            // 确定 Tab的索引 和 是否是开始和结束Tab
            if (activeSubTab == 'saveOne') {
                tabIndex = 0;
                isFirstLast = true;
            } else if (activeSubTab == 'saveAll') {
                tabIndex = 1;
                isFirstLast = false;
            } else if (activeSubTab == 'downloadAll') {
                tabIndex = 2;
                isFirstLast = true;
            }
            // 处理Tab下划线
            clearInterval(this.checkSubTabSelect);
            this.checkSubTabSelect = setInterval(() => {
                var tabs = imageSaverSubTab.$children[0].$refs.tabs;
                if (tabs[tabIndex]) {
                    var width = tabs[tabIndex].clientWidth - (isFirstLast?20:40);
                    var offsetLeft = tabs[tabIndex].offsetLeft;
                    if (tabIndex > 0) offsetLeft += 20;
                    if (width > 0) {
                        var style = imageSaverSubTab.$children[0].$children[0].$el.style;
                        // 移除动画
                        style.transition = 'none';
                        // 设置位置
                        style.transform = 'translateX('+offsetLeft+'px)';
                        // 设置宽度
                        style.width = width + 'px';
                        // 添加动画
                        setTimeout(() => {
                            style.transition = 'transform .3s cubic-bezier(.645,.045,.355,1), -webkit-transform .3s cubic-bezier(.645,.045,.355,1)';
                        }, 500);
                        clearInterval(this.checkSubTabSelect);
                    }
                }
            }, 10);
        },
        // 分包下载
        downloadPart(task, index, flag) {
            if (flag) {
                let user = commonUtils.getUser();
                taskListUtils.imageSaverRequest("/downloadPart", {uid:user.id,tid:task.id,part:index}, res => {
                    if (res.code == 200) {
                        var url = res.data;
                        if (url && url.indexOf("http")==0) {
                            location.href = url;
                        }
                    }
                });
            } else {
                this.showUpgradeNewDialog();
            }
        },
        // Ins任务不要-后面的类型
        taskNameFormat(task) {
            var name = task.fromData.url;
            var index = name.lastIndexOf("-");
            if (task.fromType=='instagram' && index!=-1) {
                name = name.substring(0, index);
            }
            return name;
        },
        // 打开Instagram页面
        openInstagramWebPage(task) {
            var param = task.fromData.url;
            var baseUrl = 'https://www.instagram.com/';
            var path = '';
            var index = param.lastIndexOf('-');
            if (index != -1) {
                var username = param.substring(0,index);
                var type = param.substring(index + 1);
                path = username + '/';
                if (type == 'post') {
                    // 贴子
                } else if (type == 'reels') {
                    // REELS
                    path = path + 'reels/';
                } else if (type == 'tags') {
                    // 标记内容
                    path = path + 'tagged/';
                }
            } else {
                // 贴子（之前的任务）
                path = param + '/';
            }
            window.open(baseUrl + path);
        },
        // 是否流量不足
        isTrafficNotEnough() {
            let user = commonUtils.getUser();
            if (user.totalBytes != -1 && user.usedBytes >= user.totalBytes) {
                return true;
            } else {
                return false;
            }
        },
        // 是否是警告，而不是失败
        isWarnNotError(task) {
            if (this.errorIsNoTraffic(task)) {
                return true;
            } else if (this.errorIsNoDiskSpace(task)) {
                return true;
            } else if (task.fromType=='instagram' && task.fromData.type=='download_all') {
                // Ins下载所有没有部分成功的说法
                return false;
            } else {
                // 部分成功
                var msg = task.msg;
                if (msg.indexOf("{") == 0) {
                    var json = JSON.parse(msg);
                    if (json.sumBytes || json.skip || json.success) {
                        return true;
                    }
                }
                // 失败
                return false;
            }
        },
        // 是否显示升级2按钮
        isShowUpgrade2Btn(task) {
            if (this.taskIsLimit(task)) {
                return true;
            } else {
                if (this.errorIsNoTraffic(task)) {
                    return this.isTrafficNotEnough();
                }
                return false;
            }
        },
        // 显示下载所有按钮，正常
        isShowDwonloadAllNormal(task) {
            var parts = this.decodeWidthParts(task);
            if (parts.length == 0) {
                // 没有分包不显示
                return false;
            } else {
                for(var i=0; i<parts.length; i++) {
                    if (!parts[i].flag) {
                        // 有分包不完整，不显示
                        return false;
                    }
                }
                var status = task.status;
                if (status == 'success') {
                    // 已完成，所有分包都完整，显示
                    return true;
                } else if (status=='error') {
                    // 失败，不显示
                    return false;
                } else {
                    // 未完成，不显示
                    return false;
                }
            }
        },
        // 显示下载所有按钮，升级
        isShowDwonloadAllUpgrade(task) {
            var parts = this.decodeWidthParts(task);
            if (parts.length == 0) {
                // 没有分包不显示
                return false;
            } else {
                for(var i=0; i<parts.length; i++) {
                    if (!parts[i].flag) {
                        // 有分包不完整，显示
                        return true;
                    }
                }
                // 所有分包都完整，不显示
                return false;
            }
        },
        // 显示升级弹窗
        showUpgradeNewDialog(isLimitInsCount) {
            let user = commonUtils.getUser();
            if (user.vip) {
                var upgradeVipDialog = this.$refs.upgradeVipDialog;
                if (isLimitInsCount) {
                    upgradeVipDialog.title = this.$t('language.paySystem.supportItem.vipPopupTitleIns');
                    upgradeVipDialog.desc = this.$t('language.paySystem.supportItem.vipPopupDescIns');
                } else if (user.totalBytes != -1 && user.usedBytes >= user.totalBytes) {
                    upgradeVipDialog.title = this.$t('language.paySystem.supportItem.vipPopupTitleTraffic');
                    upgradeVipDialog.desc = this.$t('language.paySystem.supportItem.vipPopupDescTraffic');
                } else {
                    upgradeVipDialog.title = this.$t('language.paySystem.supportItem.vipPopupTitleIns');
                    upgradeVipDialog.desc = this.$t('language.paySystem.supportItem.vipPopupDescIns');
                }
                upgradeVipDialog.isShow = true;
            } else {
                var upgradeNewDialog = this.$refs.upgradeNewDialog;
                if (isLimitInsCount) {
                    upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_ins');
                    upgradeNewDialog.curItem = 'ins';
                } else if (user.totalBytes != -1 && user.usedBytes >= user.totalBytes) {
                    upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
                    upgradeNewDialog.curItem = 'traffic';
                } else {
                    upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_ins');
                    upgradeNewDialog.curItem = 'ins';
                }
                upgradeNewDialog.isShow = true;
            }
        },
        // 错误原因是否是流量不足
        errorIsNoTraffic(task) {
            // 根据错误信息判断是否是流量不足
            return task.msg.indexOf('traffic not enough') >= 0;
        },
        // 错误原因是否是磁盘空间不足
        errorIsNoDiskSpace(task) {
            // 根据错误信息判断是否是磁盘空间不足
            return task.msg.indexOf('Disk space is insufficient') >= 0;
        },
        // 任务是否过期
        taskIsOverdue(task) {
            var overdueTime = new Date().getTime() - 1000*60*60*24*3;
            var status = task.status;
            if (status=='success' || status=='error') {
                if (status=='error' && task.msg=='limit') {
                    return false;
                }
                if (task.mtime < overdueTime) {
                    return true;
                }
            }
            return false;
        },
        // 任务是否被限制
        taskIsLimit(task) {
            return task.status=='error' && task.msg=='limit';
        },
        // 解析宽任务过期
        decodeWidthOverdue(task) {
            var isOverdue = this.taskIsOverdue(task);
            var overdueTime = task.mtime + 1000*60*60*24*3;
            var dateStr = commonUtils.i18nDateFormat(overdueTime, this.$i18n.locale);
            if (isOverdue) {
                return this.$t('language.imageSaver.taskExpiredOn',{time:dateStr});
            } else {
                return this.$t('language.imageSaver.taskStoringTill',{time:dateStr});
            }
        },
        // 解析宽任务消息
        decodeWidthMsg(task) {
            if (task.status == 'success') {
                // 成功
                return this.$t('language.common.success');
            } else if (task.status == 'error') {
                if (this.errorIsNoDiskSpace(task)) {
                    // 磁盘空间不足
                    return 'Disk space is insufficient';
                } else if (this.errorIsNoTraffic(task)) {
                    // 流量不足
                    return this.$t('language.popup.upgradeAccountPopup.insufficientTraffic');
                } else if (task.fromType=='instagram' && task.fromData.type=='download_all') {
                    // Ins下载所有没有部分成功的说法
                    return this.$t('language.imageSaver.failedToParse');
                } else {
                    var msg = task.msg;
                    // 部分成功
                    if (msg.indexOf("{") == 0) {
                        var json = JSON.parse(msg);
                        if (json.sumBytes || json.skip || json.success) {
                            return this.$t('language.common.patial');
                        }
                    }
                    // 失败
                    if (task.fromType == 'instagram') {
                        return this.$t('language.imageSaver.failedToParse');
                    } else {
                        return this.$t('language.common.failure')
                    }
                }
            } else {
                // 除了成功失败的情况，其他情况不会显示这个
                return 'undefined';
            }
        },
        // 解析宽任务分包详情
        decodeWidthParts(task) {
            var msg = task.msg;
            if (msg.indexOf("{") == 0) {
                // 分包信息
                var parts = JSON.parse(msg).parts;
                return (parts ? parts : []);
            } else {
                // 没有分包信息
                return [];
            }
        },
        // 解析宽任务消息Title
        decodeWidthMsgTitle(task) {
            if (task.status == 'success') {
                // 成功
                return this.$t('language.common.success');
            } else if (task.status == 'error') {
                var msg = task.msg;
                if (msg.indexOf("{") == 0) {
                    // 真实错误原因
                    var json = JSON.parse(msg);
                    return json.msg;
                } else {
                    // 被动失败
                    return msg;
                }
            } else {
                // 除了成功失败的情况，其他情况不会显示这个
                return 'undefined';
            }
        },
        // 解析宽任务进度
        decodeWidthProg(task) {
            if (this.isNoProg(task)) {
                return '20%';
            } else {
                return this.decodePercentage(task) + '%';
            }
        },
        // 解析宽任务进度
        decodeWidthProgText(task) {
            if (this.isNoProg(task)) {
                return '';
            } else {
                return this.decodePercentage(task) + '%';
            }
        },
        // 解析宽任务速度
        decodeWidthSpeed(task) {
            var status = task.status;
            if (status == 'create') {
                // 任务排队中
                return this.$t('language.imageSaver.taskQueue');
            } else if (status == 'run') {
                var msg = task.msg;
                if (msg.indexOf("{") == 0) {
                    // 至少处理了1个文件
                    var json = JSON.parse(msg);
                    var useTime = json.curTime - json.startTime;
                    if (useTime > 0) {
                        var bytes = Math.floor(json.curBytes / (useTime/1000));
                        return this.formatBytes(bytes) + '/s';
                    } else {
                        return '0Byte/s';
                    }
                } else {
                    // 一个文件都没处理
                    return '0Byte/s';
                }
            } else if (status == 'success') {
                // 这种情况不显示速度
                return 'undefined';
            } else if (status == 'error') {
                // 这种情况不显示速度
                return 'undefined';
            } else {
                // 目前没有这种任务状态
                return 'undefined';
            }
        },
        // 解析宽任务信息
        decodeWidthInfo(task) {
            var status = task.status;
            if (status == 'create') {
                // 任务排队中
                // return 'wait';
                return this.decodeWidthInfoJson(task);
            } else if (status == 'run') {
                // 解析详细信息
                return this.decodeWidthInfoJson(task);
            } else if (status == 'success') {
                // 解析详细信息
                return this.decodeWidthInfoJson(task);
            } else if (status == 'error') {
                if (task.msg == 'limit') {
                    // 任务被限制
                    return 'You have reached the limit of downloads';
                } else {
                    // 解析详细信息
                    return this.decodeWidthInfoJson(task);
                }
            } else {
                // 目前没有这种任务状态
                return 'undefined';
            }
        },
        // 贴子单位字符串
        postsUnitText(num) {
            if (num > 1) {
                return num + this.$t('language.imageSaver.posts');
            } else {
                return num + this.$t('language.imageSaver.post');
            }
        },
        // 文件数单位字符串
        filesUnitText(num) {
            if (num > 1) {
                return num + this.$t('language.imageSaver.taskUnitFiles');
            } else {
                return num + this.$t('language.imageSaver.taskUnitFile');
            }
        },
        // 解析宽任务信息详情
        decodeWidthInfoJson(task) {
            var msg = task.msg;
            if (msg.indexOf("{") == 0) {
                // 至少已经处理了一个文件，就会有JSON信息
                var json = JSON.parse(msg);
                if (json.prog == undefined) {
                    // 等待或遍历中
                    if (json.sumPosts) return this.postsUnitText(json.sumPosts);
                    if (json.sumCount) return this.filesUnitText(json.sumCount);
                    return 'ready';
                } else {
                    if (json.curBytes == undefined) {
                        // 兼容旧的保存所有任务
                        return (json.skip+json.success) + ' / ' + this.filesUnitText(json.skip+json.success+json.error);
                    } else {
                        var status = task.status;
                        if (status=='success' || status=='error') {
                            // 新任务，已完成
                            var curPosts = json.curPosts;
                            var sumPosts = json.sumPosts;
                            if (curPosts!=undefined && sumPosts!=undefined) {
                                return this.formatBytes(json.sumBytes) + ' · ' + this.postsUnitText(sumPosts);
                            } else {
                                return this.formatBytes(json.sumBytes) + ' · ' + this.filesUnitText(json.sumCount);
                            }
                        } else {
                            // 新任务，执行中
                            var curPosts = json.curPosts;
                            var sumPosts = json.sumPosts;
                            if (curPosts!=undefined && sumPosts!=undefined) {
                                return this.formatBytes(json.curBytes) + ' · ' + (curPosts) + ' / ' + this.postsUnitText(sumPosts);
                            } else {
                                return this.formatBytes(json.curBytes) + ' · ' + (json.skip+json.success) + ' / ' + this.filesUnitText(json.sumCount);
                            }
                        }
                    }
                }
            } else {
                if (task.status == 'error') {
                    // 被动失败
                    return '0Byte';
                } else {
                    // 任务已经开始，但是一个文件都还未处理（已修改，应该不会有这种情况）
                    return 'ready';
                }
            }
        },
        // 格式化字节（GPT写的）
        formatBytes(bytes) {
            if (bytes === 0) return '0Byte';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + '' + sizes[i];
        },
        // 预览失败处理
        previewError(event) {
            event.target.src = this.previewErrorImg;
        },
        // 解析详情
        decodeDetail(task, type) {
            if (task.msg.indexOf("{") == 0) {
                return JSON.parse(task.msg)[type];
            } else {
                return 0;
            }
        },
        // 是否是没有进度
        isNoProg(task) {
            if (task.status == 'run') {
                var msg = task.msg;
                if (msg.indexOf("{") == 0) {
                    return JSON.parse(msg).noProg;
                }
            }
            return false;
        },
        // 解析进度
        decodePercentage(task) {
            var status = task.status;
            if (status == 'create') {
                return 0;
            } else if (status == 'run') {
                var msg = task.msg;
                if (msg.indexOf("{") == 0) {
                    // JSON
                    return JSON.parse(msg).prog;
                } else {
                    // 纯数字
                    return parseInt(msg);
                }
            } else if (status == 'success') {
                return 100;
            } else if (status == 'error') {
                return 100;
            } else {
                return 0;
            }
        },
        // GA
        gaView(task) {
            var fromType = task.fromType;
            var dataType = task.fromData.type;
            if (fromType == 'instagram') {
                if (dataType == 'all') {
                    taskListUtils.imageSaverRequest("/ga", {gaType:'ins_task_all_view'});
                } else {
                    taskListUtils.imageSaverRequest("/ga", {gaType:'ins_task_upload_view'});
                }
            }
            if (fromType == 'google') {
                if (dataType == 'all') {
                    taskListUtils.imageSaverRequest("/ga", {gaType:'google_task_all_view'});
                } else {
                    taskListUtils.imageSaverRequest("/ga", {gaType:'google_task_upload_view'});
                }
            }
            if (fromType == 'web') {
                if (dataType == 'all') {
                    taskListUtils.imageSaverRequest("/ga", {gaType:'web_task_all_view'});
                } else {
                    taskListUtils.imageSaverRequest("/ga", {gaType:'web_task_upload_view'});
                }
            }
        },
        // 跳转到目标位置
        viewTask(task) {
            this.gaView(task);
            taskListUtils.imageSaverRequest("/jumpToSource", { id: task.id }, res => {
                if (res.code == 200) {
                    // 确定云盘下标
                    var index = null;
                    var drives = this.$store.getters.getUsersDrives;
                    for (var i=0; i<drives.length; i++) {
                        if (drives[i].id == res.data.tokenId) {
                            index = i;
                            break;
                        }
                    }
                    // 选择该云盘
                    if (index >= 0) {
                        this.$store.commit('setleftbannerMenuClick', drives[index].id);
                    }
                    // 跳转路径处理
                    var data = [];
                    var nodes = JSON.parse(res.data.folderName);
                    // 使用最新的云盘名称
                    nodes[nodes.length-1].name = drives[index].name;
                    for (var i=0; i<nodes.length; i++) {
                        var node = {};
                        node.fileName = nodes[i].name;
                        node.tokenId = res.data.tokenId;
                        node.cloudType = res.data.cloudType;
                        node.fileId = nodes[i].id;
                        data.push(node);
                    }
                    commonUtils.encapsulationPath(data);
                    // 跳转到云盘管理
                    res.data.folderName = nodes[0].name;
                    this.$router.push({
                        name: "cloudExploer",
                        query: res.data
                    });
                }
            });
        },
    }
};
</script>

<style>
/* 任务弹窗 */
.image_saver_task {
    top: 90px;
    position: relative;
    height: calc(100% - 90px);
    display: flex;
    flex-direction: column;
    background-color: #F2F7FE;
}

/* 底部波浪 */
.image_saver_task>.task-buttom {
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
}

/* Tab标题样式 */
.image_saver_task .el-tabs__item {
    font-weight: bolder;
    font-size: 18px;
    outline: none;
}

/* 清理 */
.image_saver_task_clear {
    height: 30px;
    line-height: 30px;
    padding-left: 35px;
    padding-right: 10px;
    background-position: 10px center;
    background-repeat: no-repeat;
    background-image: url("../../assets/images/imageSaver/clearHistory.svg");
    font-size: 14px;
    color: #5562B4;
    cursor: pointer;
    position: absolute;
    z-index: 1;
    right: 50px;
    top: 40px;
}

.image_saver_task_clear:hover {
    background-color: rgba(80, 101, 187, 0.05);
}

/* Tab整体 */
.image_saver_task_tab {
    height: 100%;
}

.image_saver_task_tab .el-tabs__header {
    padding: 35px 50px 0px 50px;
}

/* Tab内容 */
.image_saver_task_tab .el-tabs__content {
    overflow: auto;
    height: calc(100% - 120px);
    margin-top: 20px;
}

/* 滚动条 */
.image_saver_task_tab .el-tabs__content::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
}

/* 滚动条 */
.image_saver_task_tab .el-tabs__content::-webkit-scrollbar-thumb {
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #BECAE4;
    min-height: 100px;
}

/* Tab具体内容 */
.image_saver_task_tab .el-tabs__content>.el-tab-pane {
    width: calc(100% - 100px);
    min-height: 100%;
    margin: 0px 50px;
    padding: 0px;
    box-sizing: border-box;
}

/* 保存单个外框布局 */
#pane-saveOne {
    padding: 4px 20px 20px 4px;
}

/* 主体 */
.image_saver_task_body {
    flex: 1;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    overflow: auto;
}

/* 没有任务图标和文字 */
.image_saver_task_no {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    text-align: center;
    position: relative;
}

/* 保存单个任务，没有任务，单独处理 */
#pane-saveOne>.image_saver_task_no {
    margin-top: -4px;
    margin-left: 18px;
    width: calc(100% - 20px);
}

/* 没有任务图标和文字定位 */
.image_saver_task_no>.image_saver_task_no_content {
    width: 300px;
    height: 150px;
    position: absolute;
    z-index: 1;
    margin: auto;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
}

/* 没有任务文字 */
.image_saver_task_no>.image_saver_task_no_content>div {
    margin-top: 20px;
    font-size: 16px;
    font-weight: bold;
    color: #C1CBE3;
}

/* 任务未初始化 */
.image_saver_task_not_init {
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("../../assets/images/imageSaver/bigLoading.svg");
    animation: rotating 2s linear infinite;
    width: 300px;
    height: 300px;
    position: absolute;
    z-index: 2;
    margin: auto;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
}

/* 清除高度塌陷 */
.image_saver_task_items::after {
    content: "";
    display: block;
    clear: both;
}

/* 单个任务 */
.image_saver_task_item {
    width: 240px;
    height: 240px;
    margin-top: 16px;
    margin-left: 16px;
    float: left;
    position: relative;
    box-shadow: 0px 0px 4px 0px rgba(87, 94, 136, 0.3);
}

/* 任务预览图 */
.image_saver_task_item>img {
    width: 100%;
    height: 100%;
}

.image_saver_task_item>img.imagesaver_web {
    object-fit: scale-down;
}

.image_saver_task_item>img.imagesaver_instagram {
    object-fit: cover;
}

.image_saver_task_item>img.imagesaver_google {
    object-fit: contain;
}

.image_saver_task_item>img.imagesaver_instagram.imagesaver_all {
    border-radius: 50px;
}

/* 任务图标 */
.image_saver_task_all {
    width: 16px;
    height: 16px;
    background-image: url("../../assets/images/imageSaver/insTask.svg");
    position: absolute;
    z-index: 1;
    bottom: 6px;
    left: 6px;
}

.image_saver_task_item:hover>.image_saver_task_all {
    display: none;
}

/* 任务详情 */
.image_saver_task_detail {
    display: none;
    width: 100%;
    height: 26px;
    color: #FFF;
    padding-top: 5px;
    text-align: center;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0.7);
    position: absolute;
    z-index: 3;
    left: 0px;
    bottom: 0px;
}

/* Instagram成功数文字对齐 */
.image_saver_task_detail span {
    vertical-align: middle;
}

/* Instagram成功失败默认不显示 */
.detail_success,
.detail_error {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0px 5px;
    display: none;
}

/* Instagram成功数 */
.image_saver_success:hover>.image_saver_task_detail,
.image_saver_success:hover>.image_saver_task_detail>.detail_success {
    display: block;
}

/* Instagram失败数 */
.image_saver_error:hover>.image_saver_task_detail,
.image_saver_error:hover>.image_saver_task_detail>.detail_error {
    display: block;
}

/* 视频图标 */
.image_saver_task_video {
    width: 21px;
    height: 21px;
    background-image: url("../../assets/images/imageSaver/typeVideo.svg");
    position: absolute;
    z-index: 1;
    left: 10px;
    top: 10px;
}

/* 进度外框 */
.image_saver_task_prog {
    width: 34px;
    height: 34px;
    border-radius: 16px;
    box-sizing: border-box;
    background-color: rgba(255, 255, 255, 0.3);
    position: absolute;
    z-index: 1;
    right: 10px;
    top: 10px;

}

/* 进度百分比 */
.image_saver_task_prog>div {
    margin-top: 1px;
    margin-left: 1px;
}

/* 取消、预览、重试 */
.image_saver_task_cancel,
.image_saver_task_view,
.image_saver_task_retry {
    display: none;
    width: 100%;
    height: 100%;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.5);
    background-repeat: no-repeat;
    background-position: center 40%;
    padding-top: 58%;
    box-sizing: border-box;
    text-align: center;
    font-size: 26px;
    color: #FFFFFF;
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
}

/* 可以取消：未开始的任务、正在执行的任务 */
.image_saver_create:hover>.image_saver_task_cancel,
.image_saver_run:hover>.image_saver_task_cancel {
    display: block;
}

/* 成功的可以预览 */
.image_saver_success:hover>.image_saver_task_view {
    display: block;
}

/* 失败的可以重试 */
.image_saver_error:hover>.image_saver_task_retry {
    display: block;
}

/* 取消图标 */
.image_saver_task_cancel {
    background-image: url("../../assets/images/imageSaver/taskCancel.svg");
}

/* 预览图标 */
.image_saver_task_view {
    background-image: url("../../assets/images/imageSaver/taskView.svg");
}

/* 重试图标 */
.image_saver_task_retry {
    background-image: url("../../assets/images/imageSaver/taskRetry.svg");
}

/* 失败图标 */
.image_saver_task_error {
    width: 100%;
    height: 100%;
    background-image: url("../../assets/images/imageSaver/taskError.svg");
    background-color: rgba(0, 0, 0, 0.5);
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
}

.image_saver_task_item:hover>.image_saver_task_error {
    display: none;
}

/* 成功图标 */
.image_saver_task_success {
    width: 32px;
    height: 32px;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("../../assets/images/imageSaver/taskSuccess.svg");
    position: absolute;
    z-index: 1;
    right: 10px;
    top: 10px;
}

/* 宽任务集合 */
.image_saver_width_tasks {
    padding-bottom: 0px;
}

/* 单个宽任务 */
.image_saver_width_task {
    min-height: 110px;
    box-sizing: border-box;
    border: 1px solid #D3DCF0;
    background-color: #FFF;
    margin-bottom: 20px;
    position: relative;
    font-family: Arial;
}

/* 最后一个宽任务 */
.image_saver_width_task:last-child {
    margin-bottom: 0px;
}

/* 宽任务，图标 */
.image_saver_width_task_icon {
    user-select: none;
    width: 70px;
    height: 70px;
    padding: 2px;
    box-sizing: border-box;
    border: 1px solid #FFF;
    position: absolute;
    left: 20px;
    top: 20px;
}

.image_saver_width_task_icon.imagesaver_web {
    object-fit: scale-down;
}

.image_saver_width_task_icon.imagesaver_instagram {
    object-fit: cover;
}

.image_saver_width_task_icon.imagesaver_google {
    object-fit: contain;
}

.image_saver_width_task_icon.imagesaver_instagram.imagesaver_download_all,
.image_saver_width_task_icon.imagesaver_instagram.imagesaver_all {
    border-radius: 37px;
}

.image_saver_width_task:hover>.image_saver_width_task_icon.imagesaver_instagram.imagesaver_download_all,
.image_saver_width_task:hover>.image_saver_width_task_icon.imagesaver_instagram.imagesaver_all {
    border: 1px solid #5562B4;
}

/* 宽任务，名称 */
.image_saver_width_task_name2,
.image_saver_width_task_name {
    max-width: 400px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    position: absolute;
    left: 110px;
    top: 30px;
}

/* 宽任务，名称2，动作 */
.image_saver_width_task:hover>.image_saver_width_task_name2 {
    color: #5562B4;
}

/* 宽任务，名称2，动作 */
.image_saver_width_task>.image_saver_width_task_name2:hover {
    color: #3F4A8D;
    cursor: pointer;
}

/* 宽任务，名称2，点击 */
.image_saver_width_task>.image_saver_width_task_name2:active {
    color: #293166;
    cursor: pointer;
}

/* 宽任务，信息 */
.image_saver_width_task_info {
    max-width: 400px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
    color: #6F6F6F;
    position: absolute;
    left: 110px;
    top: 62px;
}

/* 宽任务，进度 */
.image_saver_width_task_prog {
    display: none;
    width: 300px;
    position: absolute;
    left: 50%;
    top: 47px;
}

/* 宽任务，等待 和 正在执行 才显示进度 */
.image_saver_width_create>.image_saver_width_task_prog,
.image_saver_width_run>.image_saver_width_task_prog {
    display: block;
}

/* 宽任务，进度背景 */
.image_saver_width_task_prog_bg {
    width: 100%;
    height: 6px;
    background: rgba(0, 0, 0, 0.03);
    position: relative;
    overflow: hidden;
}

/* 宽任务，当前进度 */
.image_saver_width_task_prog_cur {
    width: 0%;
    height: 100%;
    background: #C1CBE3;
}

/* 无限加载进度 */
.image_saver_width_task[data-noprog=Y] .image_saver_width_task_prog_cur {
    position: absolute;
    animation: move 2s linear infinite;
}

/* 无限加载进度动画 */
@keyframes move {
    0% {
        left: -20%;
    }
    100% {
        left: 100%;
    }
}

/* 宽任务，进度，左文字 */
.image_saver_width_task_prog_left {
    color: #6F6F6F;
    font-size: 14px;
    margin-top: 10px;
    float: left;
}

/* 宽任务，进度，右文字 */
.image_saver_width_task_prog_right {
    color: #6F6F6F;
    font-size: 14px;
    margin-top: 10px;
    float: right;
}

/* 宽任务，过期 */
.image_saver_width_task_overdue {
    display: none;
    color: #FD5236;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    background-repeat: no-repeat;
    position: absolute;
    left: 50%;
    top: 49px;
}

/* 宽任务，过期的显示 */
.image_saver_width_success>.image_saver_width_task_overdue {
    display: block;
}

/* 宽任务，状态 */
.image_saver_width_task_status {
    display: none;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    background-repeat: no-repeat;
    position: absolute;
    left: 50%;
    top: 49px;
}

/* 宽任务，状态，成功 */
.image_saver_width_success>.image_saver_width_task_status {
    display: block;
    color: #30A734;
    background-image: url("../../assets/images/imageSaver/widthSuccess.svg");
    padding-left: 25px;
}

/* 宽任务，状态，失败 */
.image_saver_width_error>.image_saver_width_task_status {
    display: block;
    color: #F54958;
    background-image: url("../../assets/images/imageSaver/widthError.svg");
    padding-left: 25px;
}

/* 宽任务，状态，警告 */
.image_saver_width_error[data-warn=Y]>.image_saver_width_task_status {
    display: block;
    color: #E09D00;
    background-image: url("../../assets/images/imageSaver/widthWarning.svg");
    padding-left: 25px;
}

/* 下载所有任务，被限制的任务和成功，不显示结果状态 */
.instagram_tasks>.image_saver_width_error[data-limit=Y]>.image_saver_width_task_status,
.instagram_tasks>.image_saver_width_success>.image_saver_width_task_status {
    display: none;
}

/* 宽任务，下载所有按钮 */
.image_saver_width_task_download_all {
    cursor: pointer;
    font-size: 12px;
    font-weight: bolder;
    min-width: 100px;
    padding: 0 10px;
    text-align: center;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    background-color: #5562B4;
    color: #FFF;
    position: absolute;
    right: 20px;
    top: 40px;
}

/* 宽任务，取消按钮 */
.image_saver_width_task_cancel {
    display: none;
    background-color: #FFF;
    font-size: 14px;
    cursor: pointer;
    padding: 0 10px;
    text-align: center;
    min-width: 100px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    border: 1px solid #BDBDBD;
    color: #333333;
    position: absolute;
    right: 20px;
    top: 40px;
}

/* 宽任务，取消按钮，动作 */
.image_saver_width_task_cancel:hover {
    background-color: rgba(0, 0, 0, 0.08);
}

/* 宽任务，等待 和 正在执行 才显示取消 */
.image_saver_width_create:hover>.image_saver_width_task_cancel,
.image_saver_width_run:hover>.image_saver_width_task_cancel {
    display: block;
}

/* 宽任务，查看 */
.image_saver_width_task_view {
    display: none;
    cursor: pointer;
    width: 24px;
    height: 24px;
    background-image: url("../../assets/images/imageSaver/widthView.svg");
    position: absolute;
    right: 32px;
    top: 43px;
}

/* 宽任务，成功 和 失败 才显示查看 */
.image_saver_width_success:hover>.image_saver_width_task_view,
.image_saver_width_error:hover>.image_saver_width_task_view {
    display: block;
}

/* 保存所有，失败不能查看 */
.image_saver_width_error[data-warn=N]:hover>.image_saver_width_task_view {
    display: none;
}

/* 宽任务，重试 */
.image_saver_width_task_retry {
    display: none;
    cursor: pointer;
    width: 24px;
    height: 24px;
    background-image: url("../../assets/images/imageSaver/widthRetry.svg");
    position: absolute;
    right: 90px;
    top: 43px;
}

/* 宽任务，失败 才显示重试 */
.image_saver_width_error:hover>.image_saver_width_task_retry {
    display: block;
}

/* Instagram下载任务的重试 */
.image_saver_width_tasks.instagram_tasks .image_saver_width_task_retry {
    right: 32px;
}

/* 保存所有，失败，重试图标，位置调整 */
.image_saver_width_error[data-warn=N]:hover>.image_saver_width_task_retry {
    right: 32px;
}

/* 宽任务，升级 */
.image_saver_width_task_upgrade2_download_all,
.image_saver_width_task_upgrade2,
.image_saver_width_task_upgrade {
    display: none;
    cursor: pointer;
    padding: 0 10px;
    min-width: 100px;
    text-align: center;
    border-radius: 4px;
    height: 30px;
    line-height: 30px;
    color: #FFF;
    font-size: 12px;
    font-weight: bold;
    background: linear-gradient(173deg, #FFA133 5%, #F58427 77%);
    position: absolute;
    right: 150px;
    top: 40px;
}

/* 宽任务，升级2，未付费 */
.image_saver_width_task_upgrade2 {
    right: 20px;
}

/* 宽任务，升级2，流量不足 */
.image_saver_width_task[data-traffic=Y]>.image_saver_width_task_upgrade2 {
    right: 200px;
}

/* 宽任务，升级2，下载所有 */
.image_saver_width_task_upgrade2_download_all {
    display: block;
    right: 20px;
}

/* 流量不足才显示升级 */
.image_saver_width_task[data-traffic=Y]:hover>.image_saver_width_task_upgrade2,
.image_saver_width_task[data-traffic=Y]:hover>.image_saver_width_task_upgrade {
    display: block;
}

/* 分包外框 */
.image_saver_width_task_parts {
    width: calc(100% - 110px);
    margin-top: 90px;
    margin-left: 90px;
    margin-bottom: 20px;
    display: none;
}

/* 成功或失败才显示分包信息 */
.image_saver_width_error>.image_saver_width_task_parts,
.image_saver_width_success>.image_saver_width_task_parts {
    display: block;
}

/* 高度塌陷 */
.image_saver_width_task_parts::after {
    content: "";
    display: block;
    clear: both;
}

/* 分包的宽度 */
.image_saver_width_task_parts>.image_saver_width_task_part {
    width: 338px;
}

/* 单个分包 */
.image_saver_width_task_part {
    margin-top: 10px;
    margin-left: 20px;
    height: 32px;
    line-height: 32px;
    border-radius: 2px;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, 0.08);
    float: left;
    cursor: pointer;
}

/* 单个分包动作，可下载 */
.image_saver_width_task_part[data-status=yes]:hover {
    border: 1px solid #D3DCF0;
    background-color: #F9FBFE;
}

/* 单个分包，要升级 */
.image_saver_width_task_part[data-status=no] {
    border: 1px solid #FFA133;
    background-color: rgb(255 161 51 / 5%);
}

/* 分包zip图标 */
.image_saver_width_task_part_zip {
    float: left;
    margin: 7px;
}

/* 分包数 */
.image_saver_width_task_part_num {
    float: left;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
}

/* 分包文件详情 */
.image_saver_width_task_part_info {
    float: right;
    font-size: 12px;
    color: #6F6F6F;
}

/* 分包下载图标 */
.image_saver_width_task_part_download {
    display: none;
    float: right;
    margin: 7px;
    cursor: pointer;
}

/* 显示分包下载图标 */
.image_saver_width_task_part[data-status=yes]>.image_saver_width_task_part_download {
    display: block;
}

/* 分包升级图标 */
.image_saver_width_task_part_upgrade {
    display: none;
    float: right;
    margin: 7px;
    cursor: pointer;
}

/* 显示分包升级图标 */
.image_saver_width_task_part[data-status=no]>.image_saver_width_task_part_upgrade {
    display: block;
}

/* 过期 先 隐藏所有元素 */
.image_saver_width_task[data-overdue=Y]>* {
    display: none !important;
}

/* 过期 再 显示需要的元素 */
.image_saver_width_task[data-overdue=Y]>.image_saver_width_task_overdue,
.image_saver_width_task[data-overdue=Y]>.image_saver_width_task_icon,
.image_saver_width_task[data-overdue=Y]>.image_saver_width_task_name2,
.image_saver_width_task[data-overdue=Y]>.image_saver_width_task_info {
    display: block !important;
}

/* 灰色过期详情 */
.image_saver_width_task[data-overdue=Y]>.image_saver_width_task_info {
    color: #BDBDBD;
}

/* 灰色过期时间 */
.image_saver_width_task[data-overdue=Y]>.image_saver_width_task_overdue {
    color: #BDBDBD;
}

/* 灰色过期头像 */
.image_saver_width_task[data-overdue=Y]>.image_saver_width_task_icon {
    opacity: 0.5;
}

/* 灰色过期用户名 */
.image_saver_width_task[data-overdue=Y]>.image_saver_width_task_name2 {
    opacity: 0.5;
}

/* 被限制，不显示过期时间 */
.image_saver_width_task[data-limit=Y]>.image_saver_width_task_overdue {
    display: none;
}

/* 被限制，显示升级按钮 */
.image_saver_width_task[data-limit=Y]>.image_saver_width_task_upgrade2 {
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/image_saver_task.vue